var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","d":"M-0.000349651884,49.88 C-0.09,22.09 23.24,-0.74 51.38,0 C77.38,0.7 100.11,22.17 100.000398,50.25 C99.8978273,77.8642375 77.4292375,100.167173 49.815,100.06535 C22.2007625,99.9628273 -0.102172679,77.4942375 -0.000349651884,49.88 Z M73.88,50.76 C73.2292931,49.8571377 72.46652,49.0406008 71.61,48.33 C61.61,42.3966667 51.5766667,36.51 41.51,30.67 C39,29.2 37,30.23 37,33.1 C36.9,44.9266667 36.9,56.7533333 37,68.58 C37,71.47 39,72.58 41.5,71.11 C51.6466667,65.2433333 61.7533333,59.31 71.82,53.31 C72.56,52.84 73,51.82 73.89,50.76 L73.88,50.76 Z"})));
}

PlayButton.defaultProps = {"viewBox":"0 0 100 100","version":"1.1"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
